
import Configure from '@/utils/configure'

class UserSetting {
  constructor() {
    this.prefix = `${Configure.project}:`
  }

  getViewType() {
    const viewType = localStorage.getItem(`${this.prefix}view-type`)
    return (viewType === null || viewType === '') ? 'table' : viewType
  }

  setViewType(viewType) {
    localStorage.setItem(`${this.prefix}view-type`, viewType)
  }
}

export default new UserSetting()